export const SWISH_TECHNICAL_SUPPLIER_NAME = "Kassaro AB";
export const SWISH_TECHNICAL_SUPPLIER_ORG_NUMBER = "9870569705";
